import { Component, Inject } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatTableModule } from '@angular/material/table';
import { SortUtilService } from '../../utils/sort-util.service';

@Component({
  selector: 'app-details-pop-up',
  imports: [MatTableModule, MatCardModule, MatDividerModule],
  templateUrl: './details-pop-up.component.html',
  styleUrl: './details-pop-up.component.scss',
})
export class DetailsPopUpComponent {
  displayedColumns: string[] = ['status', 'color', 'number', 'per', 'list'];
  dataSource: any = [];
  constructor(
    public dialogRef: MatDialogRef<DetailsPopUpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sortUtil:SortUtilService
  ) {
    const under = data.under.length;
    const meets = data.meets.length;
    const exceeds = data.exceeds.length;
    const exceedsSummary = this.summarizeCategory(data.exceeds);
    const meetsSummary = this.summarizeCategory(data.meets);
    const underSummary = this.summarizeCategory(data.under);


    const totalRevenue =
      exceedsSummary.total + meetsSummary.total + underSummary.total;

    // const totalData: any = localStorage.getItem('initialData');
    // const parsedTotalData = JSON.parse(totalData);

    // let totalRevenue = 0;

    // ['q1', 'q2', 'q3', 'q4'].forEach((quarter) => {
    //   parsedTotalData[quarter].forEach((item: { value: number[] }) => {
    //     totalRevenue += item.value[2];
    //   });
    // });

    this.dataSource = [
      {
        status: 'Under Performing',
        color: '#FF0000',
        number: under,
        per: totalRevenue ? ((underSummary.total / totalRevenue) * 100).toFixed(2) : 0.00,
        list: this.sortUtil.sortByFirstNumber(underSummary.names),
      },
      {
        status: 'Meets Expectation',
        color: '#000000',
        number: meets,
        per: totalRevenue ? ((meetsSummary.total / totalRevenue) * 100).toFixed(2) : 0.00,
        list: this.sortUtil.sortByFirstNumber(meetsSummary.names),
      },
      {
        status: 'Exceeds Expectation',
        color: '#000000',
        number: exceeds,
        per: totalRevenue ? ((exceedsSummary.total / totalRevenue) * 100).toFixed(2) : 0.00,
        list: this.sortUtil.sortByFirstNumber(exceedsSummary.names),
      },
    ];
  }
  closePopUp() {
    this.dialogRef.close();
  }
  sort(data: string[]): string[] {
    return [...data].sort((a, b) => {
      const getFirstNumber = (str: string) => {
        const match = str.match(/\d+/);
        return match ? parseInt(match[0], 10) : 0;
      };
      return getFirstNumber(a) - getFirstNumber(b);
    });
  }

summarizeCategory(category: any[]) {
  return category.reduce(
    (acc, item) => {
      const revenue = typeof item.revenue === 'number' && !isNaN(item.revenue) ? item.revenue : 0;
      acc.total += revenue;
      acc.names.push(item.name);
      return acc;
    },
    { total: 0, names: [] as string[] }
  );
}
}
